import { render, staticRenderFns } from "./TeacherMembershipAvailableTable.vue?vue&type=template&id=28edd2f0&scoped=true&"
import script from "./TeacherMembershipAvailableTable.vue?vue&type=script&lang=js&"
export * from "./TeacherMembershipAvailableTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28edd2f0",
  null
  
)

export default component.exports